module.exports = __webpack_public_path__ + "static/media/5.28199d99.png";